import { api, unwrapData } from 'app/store/api';
import {
    RangeReportOptions,
    RangeReportPayload,
    RangeReportPreview,
} from '../types/range-report.types';

export const rangeReportApi = api.injectEndpoints({
    endpoints: (builder) => ({
        rangeReportOptions: builder.query<RangeReportOptions, number>({
            transformResponse: unwrapData,
            query: (workspaceId) => ({
                url: `workspaces/${workspaceId}/range-reports/options`,
                method: 'GET',
            }),
        }),
        previewRangeReport: builder.mutation<
            RangeReportPreview,
            { workspaceId: number; payload: RangeReportPayload }
        >({
            transformResponse: unwrapData,
            query: ({ workspaceId, payload }) => ({
                url: `workspaces/${workspaceId}/range-reports/preview`,
                method: 'POST',
                body: payload,
            }),
        }),
        exportRangeReport: builder.mutation<
            Blob,
            { workspaceId: number; payload: RangeReportPayload }
        >({
            query: ({ workspaceId, payload }) => ({
                url: `workspaces/${workspaceId}/range-reports/export`,
                method: 'POST',
                body: payload,
                responseHandler: (response) => response.blob(),
            }),
        }),
    }),
});

export const {
    useRangeReportOptionsQuery,
    usePreviewRangeReportMutation,
    useExportRangeReportMutation,
} = rangeReportApi;
